module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.9 15.1\"><g class=\"theater-icon--on\"><rect width=\"13.6\" height=\"15.1\"></rect><rect x=\"15.1\" width=\"5.8\" height=\"15.1\"></rect></g><g class=\"theater-icon--off\"><path d=\"M0,0V15.1H20.9V0ZM13.6,13.6H1.5V1.5H13.6Zm5.8,0H15.1V1.5h4.3Z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/icons/theater.svg
// module id = 1007
// module chunks = asvp